export default  {
    controller: 'guestEditController',    
    template: require('../views/guest.edit.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/guest/components/guest.edit.component.js